import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type Props = {
  error?: string | null
  optional?: boolean
}

export function ErrorIcon(props: Props): React.JSX.Element | null {
  return props.error ? (
    <div
      className={`form-field__svg-icon${props.optional ? '--optional' : ''}`}
      data-testid='error-icon'
    >
      <FontAwesomeIcon
        icon={faExclamationCircle}
        size="1x"
        className="form-field__svg-icon--error"
      />
    </div>
  ) : null;
}
